module.exports = __webpack_public_path__ + "assets/public/imgs/network-policy-samples/3-allow-ingress.svg";